import React from "react";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { CloseLoopGridHeader, CloseLoopGridRow } from "./components";
import { useCloseLoopGridData } from "./hooks/CloseLoopGridDataContext";

export * from "./hooks/CloseLoopGridDataContext";

export const CloseLoopDashboard = () => {
    const {
        clear,
        data,
        error,
        isClearing,
        isRowLoaded,
        loadMore,
        totalCount
    } = useCloseLoopGridData();

    return <VirtualTable
        enableScrollTracking
        row={CloseLoopGridRow}
        header={
            <thead>
                <tr>
                    <CloseLoopGridHeader property="login" width={10}>
                        Login
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="loginCreatedDate" width={7}>
                        Login Created
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="lastLoginDate" width={7}>
                        Login Used
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="isAjBell" width={4}>
                        AJBS
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="masterAccountName" width={21}>
                        Account
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="applicationDate" width={18}>
                        Application
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="lastDealDate" width={7}>
                        Last Deal
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="statusDate" width={10}>
                        Status
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader property="provider" width={14}>
                        Provider
                    </CloseLoopGridHeader>
                    <CloseLoopGridHeader width={2}>
                        &nbsp;
                    </CloseLoopGridHeader>
                </tr>
            </thead>
        }
        footer={
            <TableRecordCountDisplayFooter
                totalCount={totalCount}
                reload={clear}
            />
        }
        error={error}
        isLoading={isClearing}
        isItemLoaded={isRowLoaded}
        loadMoreItems={loadMore}
        itemSize={50}
        itemCount={totalCount === data.length ? totalCount : data.length + 3}
        itemData={data}
    >
    </VirtualTable>;
};

export default CloseLoopDashboard;